import {
  ContractRetainerSpendClient,
} from "@lib/ShiOneClient";
import { useApi } from "../../utils";
import { useQuery } from "@tanstack/react-query";
import { CACHE_KEY_DETAILED_RETAINER_EXPENSE_BY_CONTRACT_ID } from "@features/services-feature/contracts/constants";
import { DetailedContractRetainerExpenseDto } from "shared-ui/src/features/contracts-feature/canonical";
export default function useGetDetailedRetainerExpenseByContractId(
  contractId: number,
) {
  const api = useApi(ContractRetainerSpendClient);

  const getDetailedRetainerExpenseByContractId = async (id: number): Promise<DetailedContractRetainerExpenseDto> => {
    const result = await api.getDetailedRetainerExpenseByContractId(id);
    return { ...result };
  };

  return useQuery<DetailedContractRetainerExpenseDto, Error>({
    queryKey: [CACHE_KEY_DETAILED_RETAINER_EXPENSE_BY_CONTRACT_ID, contractId],
    queryFn: () => getDetailedRetainerExpenseByContractId(contractId),
    enabled: contractId > 0,
  });
}
